import React from 'react';

interface SectionTitleProps {
  subtitle: string;
  title: string;
  textCenter?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ subtitle, title, textCenter = false }) => {
  return (
    <div className={`section-title ${textCenter ? 'text-center' : ''}`}>
      <div className="subtitle">{subtitle}</div>
      <h2>{title}</h2>
    </div>
  );
};

export default SectionTitle;

